// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.tooltipContainer__LFVzO {
  display: flex;
  flex-direction: column;
  gap: 10px;
  position: relative;
  padding: 5px 15px 0px 0px;
}

.closeSvg__BDFkg {
  cursor: pointer;
  position: absolute;
  right: 0;
  top: 0;
}

.facilityItem__VZbyU {
  display: flex;
  align-items: center;
  color: var(--tables-primary-row-text-main);
  font-size: 11px;
  font-style: normal;
  font-weight: 400;
  line-height: 12px;
  letter-spacing: 0.11px;
  gap: 10px;
  cursor: pointer;
}
.facilityItem__VZbyU:hover {
  color: var(--buttons-hover);
}

.mapStaticTooltip__uvABj {
  padding: 8px !important;
  opacity: 1 !important;
  filter: drop-shadow(0 0 1px rgba(12, 26, 75, 0.24));
  border-radius: 4px !important;
  text-align: left !important;
  background: var(--tables-primary-row-surface-default) !important;
}`, "",{"version":3,"sources":["webpack://./../src/components/common/Maps/components/MapTooltipStatic/style.module.scss"],"names":[],"mappings":"AA0EA;EACE,aAAA;EACA,sBAAA;EACA,SAAA;EACA,kBAAA;EACA,yBAAA;AAzEF;;AA4EA;EACE,eAAA;EACA,kBAAA;EACA,QAAA;EACA,MAAA;AAzEF;;AA4EA;EACE,aAAA;EACA,mBAAA;EACA,0CAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,sBAAA;EACA,SAAA;EACA,eAAA;AAzEF;AA2EE;EACE,2BAAA;AAzEJ;;AA6EA;EAhDE,uBAAA;EACA,qBAAA;EACA,mDAAA;EACA,6BAAA;EACA,2BAAA;EA8CA,gEAAA;AAtEF","sourcesContent":["%scrollbar-style {\n  scrollbar-color: rgba(0, 0, 0, 0.2) rgba(0, 0, 0, 0.05);\n  scrollbar-width: auto;\n\n  &::-webkit-scrollbar {\n    width: 6px;\n    height: 6px;\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-track {\n    background: rgba(0, 0, 0, 0.05);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background: rgba(0, 0, 0, 0.2);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb:hover {\n    background: #888;\n    border-radius: 3px;\n  }\n}\n@mixin scrollBar {\n  &::-webkit-scrollbar {\n    width: 6px;\n    height: 6px;\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-track {\n    background: rgba(0, 0, 0, 0.05);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background: rgba(0, 0, 0, 0.2);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb:hover {\n    background: #888;\n    border-radius: 3px;\n  }\n}\n\n@mixin ellipsis-text {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: pre-wrap;\n  word-wrap: break-word;\n  display: -webkit-box;\n  -webkit-box-orient: vertical;\n}\n\n@mixin tooltip {\n  padding: 8px !important;\n  opacity: 1 !important;\n  filter: drop-shadow(0 0 1px rgba(12, 26, 75, 0.24));\n  border-radius: 4px !important;\n  text-align: left !important;\n}\n\n@mixin modalTitle {\n  color: var(--header-title-main);\n  font-size: 18px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: 20px;\n  text-transform: uppercase;\n}\n\n.tooltipContainer {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n  position: relative;\n  padding: 5px 15px 0px 0px;\n}\n\n.closeSvg {\n  cursor: pointer;\n  position: absolute;\n  right: 0;\n  top: 0;\n}\n\n.facilityItem {\n  display: flex;\n  align-items: center;\n  color: var(--tables-primary-row-text-main);\n  font-size: 11px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 12px;\n  letter-spacing: 0.11px;\n  gap: 10px;\n  cursor: pointer;\n\n  &:hover {\n    color: var(--buttons-hover);\n  }\n}\n\n.mapStaticTooltip {\n  @include tooltip;\n  background: var(--tables-primary-row-surface-default) !important;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"tooltipContainer": `tooltipContainer__LFVzO`,
	"closeSvg": `closeSvg__BDFkg`,
	"facilityItem": `facilityItem__VZbyU`,
	"mapStaticTooltip": `mapStaticTooltip__uvABj`
};
module.exports = ___CSS_LOADER_EXPORT___;
